//This files renders the trustpilot stars based
import React from 'react'

import Score1 from './Stars/Score1'
import Score1_5 from './Stars/Score1_5'
import Score2 from './Stars/Score2'
import Score2_5 from './Stars/Score2'
import Score3 from './Stars/Score3'
import Score3_5 from './Stars/Score3_5'
import Score4 from './Stars/Score4'
import Score4_5 from './Stars/Score4_5'
import Score5 from './Stars/Score5'

const TpStars = ({trustScore, ...props}) =>{
    //Will round to the nearest value with 0.5 precision
    const score = Math.round(trustScore * 2) / 2
    switch (score){
        case 1:
            return<Score1 {...props}/>
        case 1.5:
            return <Score1_5 {...props}/>
        case 2:
            return <Score2 {...props}/>
        case 2.5:
            return <Score2_5 {...props}/>
        case 3:
            return <Score3 {...props}/>
        case 3.5:
            return <Score3_5 {...props}/>
        case 4:
            return <Score4 {...props}/>
        case 4.5:
            return <Score4_5 {...props}/>
        default:
            return <Score5 {...props}/>
    }
}







        

export default TpStars